<template>
    <v-expansion-panel class="main_menu" v-model="panel" expand v-if="charged !== undefined && charged == true">
        <v-expansion-panel-content v-for="(section, index) in sections" :key="index">
            <template v-slot:header>
                <div>{{section.name}}</div>
            </template>
            <v-flex class="main_menu__sections layout row wrap">
                <div class="main_menu__section_item lg5 mb-3" v-for="(item_section, index) in section.items" :key="index">
                    <v-list class="main_menu__list_item" :class = "{'main_menu__list_item--inactive_item' : !item_section.active}" v-if="item_section.dropdown">
                        <v-list-group no-action>
                            <template v-slot:activator>
                            <v-list-tile-avatar class="main_menu__list_item--icon_div" :title="item_section.title">
                                <component :is="item_section.component"></component>
                            </v-list-tile-avatar>
                            <v-list-tile :title="item_section.title">
                                <v-list-tile-content>
                                    <v-list-tile-title class="main_menu__section_item--list_title">{{ item_section.title }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item_section.subtitle }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            </template>

                            <v-list-tile
                                v-for="subItem in item_section.sub_items"
                                :key="subItem.title"
                                @click="$router.push({name: subItem.active ? subItem.route : '' })"
                                :title="subItem.title"
                                :class = "{'main_menu__list_item--inactive_item' : !subItem.active}"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <v-icon>{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list-group>
                    </v-list>
                    <v-list v-else class="main_menu__normal_item" :class = "{'main_menu__normal_item--inactive_item' : !item_section.active}">
                        <v-list-tile @click="$router.push({name: item_section.active ? item_section.route : ''})"  :title="item_section.title">
                            <v-list-tile-avatar class="main_menu__normal_item--icon_div">
                                <component :is="item_section.component"></component>
                            </v-list-tile-avatar>

                            <v-list-tile-content class="main_menu__section_item--text">
                                <v-list-tile-title class="main_menu__section_item--title">{{ item_section.title }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item_section.subtitle }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </div>
            </v-flex>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
    export default {
        data(){
            return{
                charged: false,
                panel: [true, true, true, true, true],
                sub_item_selected: null,
                sections: [
                    // {
                    //     id: 1,
                    //     name: 'Configuración',
                    //     items: [
                    //         {
                    //             title: 'Usuarios',
                    //             subtitle: '',
                    //             component: 'user-icon',
                    //             active: true,
                    //             dropdown: true,
                    //             sub_items:[
                    //                 {
                    //                     id: 1,
                    //                     title: 'Ver todos',
                    //                     route: 'users',
                    //                     active: true
                    //                 },
                    //                 {
                    //                     id: 2,
                    //                     title: 'Ver activos',
                    //                     route: 'users_active',
                    //                     active: true
                    //                 },
                    //                 {
                    //                     id: 3,
                    //                     title: 'Editar información de usuario',
                    //                     route: 'edit_user',
                    //                     active: true
                    //                 }
                    //             ]
                    //         }
                    //     ]
                    // },
                    {
                        id: 2,
                        name: 'Seguridad',
                        items: [
                            {
                                title: 'Accesos',
                                subtitle: '',
                                active: this.enabledItem(this.getCompany().access),
                                component: 'access',
                                dropdown: true,
                                sub_items:[
                                    // {
                                    //     id: 2,
                                    //     title: 'Por locación',
                                    //     route: 'access',
                                    //     active: this.getCompany().access.user_access
                                    // },
                                    {
                                        id: 8,
                                        title: 'Invitaciones',
                                        route: 'invitations_index',
                                        selected: false,
                                        // active: this.getCompany().invitations.admin_invitations
                                        active: true
                                    }
                                ]
                            },
                        ]
                    }
                ],
            }
        },
        beforeRouteEnter(to, from, next) {
            setTimeout(() => {
                next(vm => {
                    vm.charged = true; // ✅ Se activa la bandera
                });
            }, 1000);
        },
        computed: {
        },
        mounted(){
            this.charged = true
        },
        methods: {
            enabledItem(company_object){
                var visible = Object.entries(company_object).filter(([key, value]) => value !== "" && value === true).length > 0 ? true : false
                return visible
            }
        }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/menu_page/MainMenuPage.vue